import { Routes, Route } from 'react-router-dom';
import QuizEditorDashboard from './QuizEditorDashboard';
import CreateQuiz from './CreateQuiz';
import ManageQuizzes from './ManageQuizzes';
import EditQuiz from './EditQuiz';

function QuizEditor() {
    return (
        <Routes>
            <Route path="/" element={<QuizEditorDashboard />} />
            <Route path="/create" element={<CreateQuiz />} />
            <Route path="/manage" element={<ManageQuizzes />} />
            <Route path="/edit/:id" element={<EditQuiz />} />
        </Routes>
    );
}

export default QuizEditor;
